<template>
  <div ref="widgetMarketplaceReviews" class="frisbuy-marketplace-reviews">
    <div
      v-if="props.settings.gallery.header.html"
      v-html="props.settings.gallery.header.html"
    ></div>

    <!-- #region Product Rating -->
    <div
      v-if="props.productRating"
      class="frisbuy-marketplace-reviews__product-raiting"
    >
      <h2>Рейтинг товара</h2>

      <div class="frisbuy-product-rating">
        <RatingBar
          :divisionByRating="divisionByRating"
          :isSoftStarIcon="isSoftStarIcon"
        />

        <div class="frisbuy-product-rating__info">
          <div
            v-if="props.productRating?.avgRating"
            class="frisbuy-product-rating__stars"
          >
            <Vue3StarRating
              :modelValue="props.productRating.avgRating"
              :numberOfStars="5"
              :starSize="22"
              :starColor="'#606266'"
              :inactiveColor="'#E9E9EB'"
              :disableClick="true"
              :customSvg="isSoftStarIcon ? StarSoftRounded : StarRounded"
            />

            <span>
              {{ props.productRating.avgRating }}
            </span>
          </div>

          <div class="frisbuy-product-rating__counts">
            <span>
              {{ props.productRating.reviewsCount }}
              {{ getPluralizatedRatingCount() }}
            </span>
            <span>
              {{ props.productRating.allReviewsCount }}
              {{ getPluralizatedReviewsCount() }}
            </span>
          </div>
        </div>

        <button
          class="frisbuy-image-upload-button"
          widget-iu-button="true"
          onclick="iuWidget.open()"
        >
          <span class="frisbuy-image-upload-button__default-text">
            Добавить отзыв
          </span>
        </button>
      </div>
    </div>
    <!-- #endregion Product Rating -->

    <!-- #region Customers Photos -->
    <div
      v-if="allCustomersMediaList.length > 0"
      class="frisbuy-marketplace-reviews__customers-photos"
    >
      <h3>Фото покупателей</h3>

      <ArrowButton
        v-show="isShowLeftScrollArrow"
        customClass="frisbuy-marketplace-reviews__customers-photos-button"
        direction="left"
        @click="scrollCustomersPhotos('left')"
      />

      <div
        class="frisbuy-marketplace-reviews__customers-photos-scroll-container"
        ref="customersPhotoScrollContainer"
        @scroll="
          () => loadCustomersMediaOnScroll(customersPhotoScrollContainer, 0.8)
        "
      >
        <div class="frisbuy-marketplace-reviews__customers-photos-list">
          <MediaList
            :mediaList="allCustomersMediaList"
            :mediaWidth="allCustomersMediaListItemsWidth"
            @selectMedia="(media) => selectPost(media.postId, media)"
          />
        </div>
      </div>

      <ArrowButton
        v-show="isShowRightScrollArrow"
        customClass="frisbuy-marketplace-reviews__customers-photos-button"
        direction="right"
        @click="scrollCustomersPhotos('right')"
      />
    </div>
    <!-- #endregion -->
    <div
      v-if="isHasSummary"
      class="frisbuy-marketplace-reviews__summary-section"
    >
      <div class="frisbuy-marketplace-reviews__summary-description">
        <span class="frisbuy-marketplace-reviews__summary-title">
          Что говорят люди
        </span>
        <span class="frisbuy-marketplace-reviews__summary-subtitle">
          собирательный отзыв на основе пользовательских мнений
        </span>
      </div>
      <span
        class="frisbuy-marketplace-reviews__summary-text"
        v-html="props.productRating?.summary?.text || ''"
      >
      </span>
    </div>
    <!-- #region Customers Photos -->

    <!-- #region Customers Reviews -->
    <div class="frisbuy-marketplace-reviews__customers-reviews">
      <h3>Все отзывы</h3>

      <div class="frisbuy-marketplace-reviews__filters">
        <div
          v-if="props.extraData?.currentVariantPostsCount"
          class="frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews--min-full"
        >
          <FrSegmented
            v-model="filterSegment"
            :options="[
              { label: 'Все отзывы', value: 'false' },
              { label: `Этот вариант товара (${ props.extraData.currentVariantPostsCount || 0 })`, value: 'true' },
            ]"
            :defaultOption="{ label: 'Все отзывы', value: 'false' }"
          />
        </div>

        <div class="frisbuy-marketplace-reviews__filter">
          <label>Показать с оценкой</label>

          <FrSelect
            v-model="filterRating"
            :options="[
              { value: undefined, text: 'Все' },
              { value: 5, text: '5 звезд' },
              { value: 4, text: '4 звезды' },
              { value: 3, text: '3 звезды' },
              { value: 2, text: '2 звезды' },
              { value: 1, text: '1 звезда' },
            ]"
            :defaultOption="{ value: 0, text: 'Все' }"
          />
        </div>

        <div class="frisbuy-marketplace-reviews__filter">
          <label>Сортировка</label>

          <FrSelect
            v-model="filterSort"
            :options="[
              { value: 'desc', text: 'Сначала новые' },
              { value: 'asc', text: 'Сначала старые' },
            ]"
            :defaultOption="{ value: 'desc', text: 'Сначала новые' }"
          />
        </div>
      </div>

      <ul
        v-if="filteredPostList.length"
        class="frisbuy-marketplace-reviews__list"
      >
        <template
          v-for="(post, postIndex) in filteredPostList"
          :key="postIndex"
        >
          <li v-if="post" class="frisbuy-marketplace-reviews__list-item">
            <CustomerReview
              :customerName="
                post.instagramPost.authorUser.fio ||
                `@${post.instagramPost.authorUser.username}`
              "
              :reviewDate="getParsedReviewDate(post)"
              :reviewTime="getParsedReviewTime(post)"
              :reviewMarketplace="post.frisbuyPost.marketplaceName"
              :rating="post.frisbuyPost.rating"
              :mediaList="post.media"
              :isShowMedia="post.instagramPost.hasMedia"
              :negativeComment="post.frisbuyPost.negativeComment"
              :positiveComment="post.frisbuyPost.positiveComment"
              :text="post.frisbuyPost.text"
              :isSoftStarIcon="isSoftStarIcon"
              @selectMedia="
                (media) => selectPost(post.instagramPost.frisbuyId, media)
              "
            />
          </li>
        </template>
      </ul>
      <span v-else class="frisbuy-marketplace-reviews-not-found-text">
        Отзывы по выбранным фильтрам не найдены
      </span>
    </div>
    <!-- #endregion Customers Reviews -->

    <!-- #region Pagination -->
    <div
      v-if="countOfPages > 0"
      class="frisbuy-marketplace-reviews__pagination"
    >
      <PaginationPanel
        :countOfPages="countOfPages"
        :selectedPage="selectedPage"
        @selectPage="(page) => selectPage(page)"
      />
    </div>
    <!-- #endregion Pagination -->
  </div>

  <PopupReviewPost
    v-if="selectedPost && selectedMediaIndex !== null"
    :post="selectedPost"
    :selectedMediaIndex="selectedMediaIndex"
    :showLeftArrow="Boolean(prevPost)"
    :showRightArrow="Boolean(nextPost)"
    :settings="props.settings"
    :allCustomersMediaList="allCustomersMediaList"
    :reviewDate="getParsedReviewDate(selectedPost)"
    :reviewTime="getParsedReviewTime(selectedPost)"
    :reviewMarketplace="selectedPost.frisbuyPost.marketplaceName"
    @sendAnaliticEvent="(event: string, params: any) => sendAnaliticEvent(event, params)"
    @selectPrevPost="selectPrevPost"
    @selectNextPost="selectNextPost"
    @selectPost="(postId, media) => selectPost(postId, media)"
    @requestToLoadCustomersMedia="() => loadCustomersMediaOnPopupRequest()"
    @close="closePopup"
  />
</template>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");

.frisbuy-marketplace-reviews {
  &,
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  max-width: 100vw;

  h2,
  h3 {
    font-family: Inter, sans-serif;
    font-weight: 700;
    line-height: 28px;
    text-align: left;

    margin: 0;
  }

  h2 {
    font-size: 25px;
  }

  h3 {
    font-size: 18px;

    margin-top: 14px;
  }

  .frisbuy-marketplace-reviews__product-raiting {
    font-family: Inter, sans-serif;

    .frisbuy-product-rating {
      display: flex;
      position: relative;
      justify-content: space-between;

      margin-top: 20px;

      &,
      * {
        font-family: inherit;
      }

      .frisbuy-product-rating__info {
        display: flex;
        flex-direction: column;
        align-items: end;

        .frisbuy-product-rating__stars {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;

          align-items: center;

          gap: 0 12px;

          span {
            font-family: Inter, sans-serif;
            font-size: 16px;
            font-weight: 700;
            line-height: 24px;

            color: #303133;
          }
        }

        .frisbuy-product-rating__counts {
          margin-top: 10px;

          font-size: 13px;
          font-weight: 400;
          line-height: 22px;

          span:last-child {
            margin-left: 10px;
          }
        }
      }

      .frisbuy-image-upload-button {
        position: absolute;
        inset: auto 0 0 auto;

        width: 280px;
        height: 38px;

        border: 1px solid #303133;
        border-radius: 4px;

        color: #303133;
        background-color: transparent;

        font-family: Inter;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
      }
    }
  }

  .frisbuy-marketplace-reviews__customers-photos {
    position: relative;
    max-width: 100%;

    .frisbuy-marketplace-reviews__customers-photos-button {
      margin-top: 24px;
    }

    .frisbuy-marketplace-reviews__customers-photos-scroll-container {
      max-width: 100%;
      overflow-x: auto;
      overflow-y: hidden;

      margin: 20px 50px 0 50px;

      .frisbuy-marketplace-reviews__customers-photos-list {
        display: flex;
        position: relative;
        width: fit-content;
        gap: 5px;
        overflow-x: auto;
      }
    }
  }

  .frisbuy-marketplace-reviews__customers-reviews {
    .frisbuy-marketplace-reviews__filters {
      display: flex;
      position: relative;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;

      gap: 10px 20px;

      margin-top: 20px;

      .frisbuy-marketplace-reviews__filter {
        display: flex;
        position: relative;

        flex-direction: row;
        flex-wrap: nowrap;

        width: 100%;
        min-width: 265px;
        height: 32px;

        flex: 1 1 0px;
        gap: 0 12px;

        &.frisbuy-marketplace-reviews--min-full {
          min-width: fit-content;
        }

        label {
          font-family: Inter, sans-serif;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;

          color: #606266;

          min-width: fit-content;

          align-self: center;
        }
      }
    }

    .frisbuy-marketplace-reviews__list {
      list-style-type: none;

      margin: 0;
      padding: 0;

      .frisbuy-marketplace-reviews__list-item {
        padding: 20px 0;

        &:not(:last-child) {
          border-bottom: 1px solid #dcdfe6;
        }
      }
    }

    .frisbuy-marketplace-reviews-not-found-text {
      display: block;

      font-family: Inter, sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #606266;
      min-width: -moz-fit-content;
      min-width: fit-content;
      text-align: center;

      margin-top: 20px;
    }
  }

  .frisbuy-marketplace-reviews__pagination {
    margin-top: 20px;
  }

  .frisbuy-marketplace-reviews__summary-section {
    display: flex;
    flex-direction: column;
    gap: 8px;

    margin: 14px 0 20px;

    font-family: Inter, sans-serif;
  }

  .frisbuy-marketplace-reviews__summary-description {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .frisbuy-marketplace-reviews__summary-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    color: #303133;
  }

  .frisbuy-marketplace-reviews__summary-subtitle {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: #909399;
  }

  .frisbuy-marketplace-reviews__summary-text {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: #303133;

    white-space: break-spaces;
  }
}

// media queries
.frisbuy-marketplace-reviews {
  container-type: inline-size;
  @container (max-width: 748px) {
    .frisbuy-marketplace-reviews__product-raiting {
      .frisbuy-product-rating {
        .frisbuy-image-upload-button {
          width: 160px;
        }
      }
    }
  }
}

.frisbuy-marketplace-reviews {
  container-type: inline-size;

  @container (max-width: 549px) {
    .frisbuy-marketplace-reviews__product-raiting {
      .frisbuy-product-rating {
        flex-direction: column;

        .frisbuy-rating-bar {
          margin-top: 20px;
        }

        .frisbuy-product-rating__info {
          align-items: start;
          order: -1;
        }

        .frisbuy-image-upload-button {
          position: relative;
          order: 1;

          width: 100%;

          margin-top: 20px;
        }
      }
    }

    .frisbuy-marketplace-reviews__customers-photos {
      .frisbuy-marketplace-reviews__customers-photos-button {
        display: none;
      }

      .frisbuy-marketplace-reviews__customers-photos-scroll-container {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }
}
</style>

<script setup lang="ts">
import {
  computed,
  defineProps,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  ref,
  watch,
} from "vue";
import CustomerReview from "./components/CustomerReview.vue";
import PopupReviewPost from "./components/PopupReviewPost/PopupReviewPost.vue";
import {
  imageWithPostId,
  IMarketplaceReviewsPost,
  productRating,
} from "./interfaces";
import MediaList from "./components/MediaList.vue";
import ArrowButton from "./components/ArrowButton.vue";
import PaginationPanel from "./components/Pagination/PaginationPanel.vue";
import FrSelect from "./components/FrSelect/FrSelect.vue";
import FrSegmented from "./components/FrSegmented/FrSegmented.vue";
import RatingBar, { TRating } from "./components/RatingBar/RatingBar.vue";
import Vue3StarRating from "vue3-star-ratings";
import StarRounded from "./Icons/StarRounded.vue";
import StarSoftRounded from "./Icons/StarSoftRounded.vue";
import { onMounted } from "vue";
import {
  getCustomersMediaList,
  getPostsInfo,
  TCustomersMediaList,
  TPostsFilterOptions,
} from "./api/api";
import { addSchemaToPage } from "@/common/services/SchemaOrg/SchemaOrg";
import { sendToGa4Dictionary } from "../../helpers.js";
import { sendFrisbuyAnalyticsEvent } from "@/common/services/FrisbuyAnalytics/FrisbuyAnalytics";
import widgetTypes from "@/common/consts/widgetTypes.js";

//#region Schema.org
onBeforeMount(() => {
  if (!props.productRating || props.productRating.reviewsCount <= 0) {
    return;
  }

  const bestRating = 5;
  // NOTE: if ratingValue === 0 and worstRating === 1, then will be error
  const worstRating = 1;
  const product = props.productRating.sku[0];

  const reviews = filteredPostList.value.map((post) => {
    const ratingValue =
      post.frisbuyPost.rating > 0 ? post.frisbuyPost.rating : bestRating;

    return {
      "@type": "Review",

      author: {
        "@type": "Person",
        name:
          post.instagramPost.authorUser.fio ||
          `@${post.instagramPost.authorUser.username}`,
      },
      datePublished: getParsedReviewDate(post),
      reviewBody: `${post.frisbuyPost.text}\n${post.frisbuyPost.positiveComment}\n${post.frisbuyPost.negativeComment}`,

      reviewRating: {
        "@type": "Rating",
        bestRating: bestRating,
        ratingValue: ratingValue,
        worstRating: worstRating,
      },
    };
  });

  const productAvgRating =
    props.productRating.avgRating > 0
      ? props.productRating.avgRating
      : bestRating;

  const SchemaorgProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.name,
    image: product.thumbUrl,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: productAvgRating,
      bestRating: bestRating,
      worstRating: worstRating,
      reviewCount: props.productRating.reviewsCount,
    },
    offers: {
      "@type": "AggregateOffer",
      url: product.vendorShopUrl,
      priceCurrency: product.currencyCode,
      price: product.price,
      offerCount: props.productRating.allReviewsCount,
    },
    review: reviews,
  };

  addSchemaToPage(SchemaorgProduct);
});
//#endregion Schema.org

const props = defineProps<{
  settings: { [key: string]: any };
  mobileSettings: Object;
  propPostList: Array<IMarketplaceReviewsPost>;
  lastPage: Boolean;
  propPostCount: number;
  productRating?: productRating;
  extraData: { currentVariantPostsCount?: number };
}>();

const hadSeen = ref(false);
const inViewTimeout = ref<number | undefined>(undefined);
const had5SecInView = ref(false);

const isLastPage = computed(() => {
  return selectedPage.value === countOfPages.value;
});

const postList = ref<IMarketplaceReviewsPost[]>(props.propPostList);

const filteredPostList = computed<IMarketplaceReviewsPost[]>(() => {
  const filtered = postList.value.slice(
    (selectedPage.value - 1) * perPage,
    selectedPage.value * perPage
  );

  updateCountOfPages();

  return filtered;
});

// Product rating
const divisionByRating = computed<TRating[] | []>(() => {
  if (!props.productRating) {
    console.error("productRating not defined");

    return [];
  }

  const productRating: Array<TRating> = Object.values(
    props.productRating.divisionByRating
  ).map((value, index) => {
    return {
      label: String(index + 1),
      count: Number(value),
    };
  });

  return productRating.reverse();
});

const isSoftStarIcon = computed(() => {
  return props.settings.gallery.starIconType === "1";
});

const isHasSummary = computed(() => {
  if (!props.productRating) return false;

  return props.productRating.summary;
})

function isElementInView(element: any, isFull = false) {
  if (!element) return;

  const { top, bottom, height } = element.getBoundingClientRect();
  const { innerHeight: windowHeight } = window;

  if (isFull) {
    return (
      (height > windowHeight && bottom > 0 && bottom < windowHeight) ||
      (top > 0 && bottom < windowHeight)
    );
  } else {
    return top < windowHeight;
  }
}

function scrollHandler() {
  const InView5SecHandler = () => {
    had5SecInView.value = true;
    sendAnaliticEvent(
      "Eyesight5Sec",
      window.location.href,
      true,
      true
    );
  };

  nextTick(() => {
    const firstItem = widgetMarketplaceReviews.value?.querySelector(
      ".frisbuy-marketplace-reviews__list-item"
    );
    if (
      !had5SecInView.value &&
      isElementInView(widgetMarketplaceReviews.value, true)
    ) {
      window.clearTimeout(inViewTimeout.value);

      inViewTimeout.value = setTimeout(InView5SecHandler, 5000);
    } else {
      window.clearTimeout(inViewTimeout.value);
    }

    if (
      !hadSeen.value &&
      isElementInView(firstItem || widgetMarketplaceReviews.value, true)
    ) {
      hadSeen.value = true;
      sendAnaliticEvent("Eyesight", window.location.href, true, true);
    }
  });
}

function sendGAEvent(
  action: any,
  label: any,
  sendToClient: any,
  isNonInteraction: any
) {
  const originalAction = action;

  const { settings } = props;

  const {
    categoryPrefix,
    actionPrefix,
    trackingSkuId,
    trackingTagCode
  } = settings.analytics;
  const { analytics } = settings;
  const category = `Frisbuy_Gallery_${
    categoryPrefix + settings.customerCode
  }`;
  const labelItemPosition = [
    "fbProduct",
    "igCode",
    "slide",
    "link",
    "linklabel",
    "product",
    "variation",
    "offer",
    "index",
    "swipeType",
    "shareType",
    "queued",
    "load",
    "bundle",
    "domInject",
    "filter",
  ];
  const labelString =
    typeof label === "object"
      ? labelItemPosition.reduce((labelString, currentLabelItem) => {
          if (!Object.hasOwn(label, currentLabelItem)) return labelString;

          return (
            (labelString ? labelString + "_" : labelString) +
            currentLabelItem +
            label[currentLabelItem]
          );
        }, "")
      : label;

  if (!action.includes("ClickMainLink")) {
    action = `${action}_gallery${settings.galleryId}_embedID${
      settings.embedId + actionPrefix + trackingSkuId + trackingTagCode
    }`;
  }

  if (action.includes("FilterElastic")) {
    const { elasticFilter } = settings.analytics;

    let filterValue = 0;

    if (elasticFilter) {
      filterValue = elasticFilter.elasticTitle;
    }

    action = `FilterElastic_gallery${settings.galleryId}_embedID${
      settings.embedId
    }_filter${
      filterValue + actionPrefix + trackingSkuId + trackingTagCode
    }`;
  }

  if (
    settings.analytics?.elasticFilter &&
    !action.includes("FilterElastic")
  ) {
    const { gender, color, categoryId } = settings.analytics.elasticFilter;

    action += `_cat${categoryId}_gender${gender}_color${color}`;
  }

  if (settings.analytics?.ga.sendToGa) {
    if (settings.verbose) {
      console.log(
        `%cSend event: %c${category} %c${action} %c${labelString}`,
        "color: red; font-weight: bold",
        "color: blue",
        "color: green",
        "color: darkcyan"
      );
    }

    // GA4
    if (window.frisbuyGa4) {
      sendToGa4Dictionary(
        originalAction,
        { settings: props.settings },
        label,
        true,
        widgetTypes.MARKETPLACE_REVIEW,
      );
    }
  }

  if (!sendToClient) return;

  if (analytics?.gtm && analytics?.gtm.eventName) {
    const { gtm } = analytics;
    const gtmPayload = Object.assign(gtm.static || {}, {
      event: gtm.eventName,
      [gtm.eventCategory]: "Frisbuy_Gallery",
      [gtm.eventAction]: action,
      [gtm.eventLabel]: labelString,
      [gtm.eventNonInteractive]: isNonInteraction,
    });

    window.frisbuyGTM(gtmPayload);
  }

  if (analytics?.ga.sendToClient) {
    if (settings.verbose) {
      console.log(
        `${window["GoogleAnalyticsObject"]}('send', 'event', 'Frisbuy_Gallery', '${action}', '${labelString}')`
      );
    }

    if (window.frisbuyGa4) {
      sendToGa4Dictionary(
        originalAction,
        { settings: props.settings },
        label,
        false,
        widgetTypes.MARKETPLACE_REVIEW,
      );
    }
  }
}

function sendYMEvent(action: any, label: any) {
  const {
    galleryId: gallery,
    embedId: embedID,
    skuId,
    tagCode,
  } = props.settings;
  const clientCounterId = props.settings.analytics?.ym.clientCounterId;
  const conunterId = `yaCounter${clientCounterId}`;
  const ymParams = typeof label === "object" ? label : {};

  if (!clientCounterId || !window[conunterId]) {
    return;
  }

  Object.assign(ymParams, {
    gallery,
    embedID,
    widgetType: widgetTypes.MARKETPLACE_REVIEW,
  });

  if (skuId) {
    ymParams.sku = skuId;
  }

  if (tagCode) {
    ymParams.tagCode = tagCode;
  }

  if (ymParams.linklabel) {
    ymParams.linklabel = ymParams.linklabel.replace(/[^\w]+/g, "+");
  }

  window[conunterId].reachGoal(`Frisbuy${action}`, ymParams, () => {
    if (!props.settings.verbose) return;

    console.log(conunterId + ".push", `Frisbuy${action}`, ymParams);
  });
}

function sendAnaliticEvent(
  action: any,
  label: any,
  sendToClient = true,
  isNonInteraction = false
) {
  sendGAEvent(action, label, sendToClient, isNonInteraction);
  sendYMEvent(action, label);

  // [START] Frisbuy Analytics
  const frisbuyParams = {
    srcDomain: props.settings.srcDomain,

    embedId: props.settings.embedId,
    widgetType: widgetTypes.MARKETPLACE_REVIEW,
    galleryId: props.settings.galleryId,
    skuId: props.settings.skuId,
    skuGroupId: props.settings.groupId,
    categoryId: props.settings.categoryId,
    tagCode: props.settings.tagCode,
    frUId: props.settings.frisbuyUID,
  };

  // TODO: check `label` on correct data
  if (typeof label === "object") {
    Object.assign(frisbuyParams, label);
  }

  sendFrisbuyAnalyticsEvent(action, frisbuyParams);
  // [END] Frisbuy Analytics
}

function getPluralizatedRatingCount() {
  if (!props.productRating) {
    return "";
  }

  const lastTwo = Math.abs(props.productRating.reviewsCount) % 100;
  const lastOne = Math.abs(props.productRating.reviewsCount) % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return "оценок";
  }

  if (lastOne === 1) {
    return "оценка";
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return "оценки";
  }

  return "оценок";
}

function getPluralizatedReviewsCount() {
  if (!props.productRating) {
    return "";
  }

  const lastTwo = Math.abs(props.productRating.allReviewsCount) % 100;
  const lastOne = Math.abs(props.productRating.allReviewsCount) % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return "отзывов";
  }

  if (lastOne === 1) {
    return "отзыв";
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return "отзыва";
  }

  return "отзывов";
}

// Customers photo
const allCustomersMediaList = ref<Array<imageWithPostId>>([]);
const postListWithImages = ref<IMarketplaceReviewsPost[]>([]);

const customersPhotoScrollContainer = ref<HTMLElement | null>(null);

onMounted(() => {
  updateAllCustomersMediaList().then(() => {
    nextTick(() => {
      // NOTE: need for fill all visible container with posts
      loadCustomersMediaOnScroll(customersPhotoScrollContainer.value, 0.8);
    });
  });

  scrollHandler();
  window.addEventListener("scroll", scrollHandler);

  const { embedId, widgetStart } = props.settings;
  const entries = (performance && performance.getEntries()) || null;
  const times: any = {};

  if (entries) {
    if (widgetStart) {
      times.domInject = (performance.now() - widgetStart).toFixed(2);
    }

    entries.forEach((entry) => {
      if (entry.name.includes(embedId)) {
        times.queued = entry.startTime.toFixed(2);
        times.load = entry.duration.toFixed(2);
      } else if (
        entry.name.includes("www.frisbuy.ru") &&
        entry.name.includes("compiled")
      ) {
        times.bundle = entry.duration.toFixed(2);
      }
    });

    sendAnaliticEvent("TimeLoad", times, false, true);
  }

  sendAnaliticEvent("Load", window.location.href, true, true);

  if (props.settings.gallery.elasticFilter) {
    sendAnaliticEvent("FilterElastic", window.location.href, true, true);
  }
});

let customersMediaScrollPage = 1;
let loadCustomersMediaErrorsCount = 0;
let maxLoadCustomersMediaErrorsCount = 5;
let hasActiveRequest = false;
const isShowLeftScrollArrow = ref(true);
const isShowRightScrollArrow = ref(true);
async function loadCustomersMediaOnScroll(
  scrollEl: HTMLElement | null,
  scrollCoef = 1
) {
  if (hasActiveRequest || !scrollEl) {
    return;
  }

  //#region ScrollArrows visible
  isShowLeftScrollArrow.value = scrollEl.scrollLeft > 0;

  const scrollRight = scrollEl.scrollLeft + scrollEl.offsetWidth;
  isShowRightScrollArrow.value = scrollRight < scrollEl.scrollWidth;
  //#endregion ScrollArrows visible

  if (!scrollEl || customersMediaScrollPage >= maxCountOfPages) {
    console.warn(
      "returned",
      !scrollEl,
      customersMediaScrollPage,
      maxCountOfPages
    );
    return;
  }

  const scrollElScrollWidth = scrollEl.scrollWidth * scrollCoef;
  const scrollLeftPos = scrollEl.scrollLeft;
  const scrollRightPos = scrollLeftPos + scrollEl.clientWidth;

  if (
    scrollRightPos >= scrollElScrollWidth &&
    loadCustomersMediaErrorsCount < maxLoadCustomersMediaErrorsCount
  ) {
    try {
      hasActiveRequest = true;
      await updateAllCustomersMediaList();
      hasActiveRequest = false;
      customersMediaScrollPage += 1;

      // NOTE: need for fill all visible container with posts
      loadCustomersMediaOnScroll(scrollEl, scrollCoef);
    } catch (e) {
      loadCustomersMediaErrorsCount += 1;
      hasActiveRequest = false;

      if (loadCustomersMediaErrorsCount >= maxLoadCustomersMediaErrorsCount) {
        console.error("Failed to load customers media");
        return;
      } else {
        loadCustomersMediaOnScroll(scrollEl, scrollCoef);
      }
    }
  }
}

async function loadCustomersMediaOnPopupRequest() {
  customersMediaScrollPage += 1;
  await updateAllCustomersMediaList();
}

function scrollCustomersPhotos(direction: "left" | "right") {
  if (!customersPhotoScrollContainer.value) {
    console.error(
      "Ref element 'customersPhotoScrollContainer' doesn't exists'"
    );
    return;
  }

  sendAnaliticEvent(`Swipe`, window.location.href);

  const scrollCoef = direction === "left" ? -1 : 1;
  const percentOfScroll = 0.8;
  const scrolWidth =
    customersPhotoScrollContainer.value.offsetWidth * percentOfScroll;

  customersPhotoScrollContainer.value.scrollBy({
    behavior: "smooth",
    left: scrolWidth * scrollCoef,
    top: 0,
  });
}

onMounted(() => {
  changeAllCustomersMediaListItemsWidth();
  window.addEventListener("resize", changeAllCustomersMediaListItemsWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandler);
  window.removeEventListener("resize", changeAllCustomersMediaListItemsWidth);
});

let allCustomersMediaListItemsWidth = ref<string>();

function changeAllCustomersMediaListItemsWidth() {
  if (document.body.clientWidth >= 550) {
    allCustomersMediaListItemsWidth.value = "100px";
  } else {
    allCustomersMediaListItemsWidth.value = "72px";
  }
}

// Pagination and filters
const postCount = ref(props.propPostCount);
const countOfPages = ref(0);
const perPage = postList.value.length;
const maxCountOfPages = postCount.value / perPage;
onBeforeMount(() => {
  updateCountOfPages();
});

function updateCountOfPages() {
  countOfPages.value = Math.ceil(postCount.value / perPage);
}

const selectedPage = ref(1);
function selectPage(page: number) {
  selectedPage.value = page;

  sendAnaliticEvent(
    "NextPage",
    ++page,
    props.settings.analytics.sendNextPageToClient
  );

  updatePostList();

  scrollWidgetToTop();
}

const widgetMarketplaceReviews = ref<HTMLElement | null>(null);
function scrollWidgetToTop() {
  widgetMarketplaceReviews.value?.scrollIntoView({
    block: "start",
    behavior: "smooth",
  });
}

const filterSegment = ref();
const filterSort = ref();
const filterRating = ref();

// NOTE: if need clear postLIst on filter update
watch(filterRating, () => {
  postList.value = [];
});

watch([filterSegment], async () => {
  selectedPage.value = 1;

  updatePostList(undefined, true);
});

watch(
  [filterRating, filterSort],
  async ([newFilterRating], [oldFilterRating]) => {
    if (newFilterRating?.value !== oldFilterRating?.value) {
      selectedPage.value = 1;
    }

    updatePostList();
  }
);

async function updateAllCustomersMediaList() {
  const { embedId, skuId, groupId, srcDomain } = props.settings;

  try {
    const newCustomersMediaList: TCustomersMediaList =
      await getCustomersMediaList({
        embedId,
        skuId,
        groupId,
        srcDomain,
        lastPostId: allCustomersMediaList.value.at(-1)?.postId,
      });

    if (!newCustomersMediaList?.imagesWithPostId) {
      return;
    }
    const newPostsMediaList: Array<imageWithPostId> =
      newCustomersMediaList.imagesWithPostId;

    const newPostListWithImages: Array<IMarketplaceReviewsPost> =
      newCustomersMediaList.postList;

    newPostsMediaList.forEach((newMedia) => {
      const isRealyNewMedia = !allCustomersMediaList.value.find((media) => {
        return media.imageUrl === newMedia.imageUrl;
      });

      if (isRealyNewMedia) {
        allCustomersMediaList.value.push(newMedia);

        const isRealyNewPost = !postListWithImages.value.find((post) => {
          return post.instagramPost.frisbuyId === newMedia.postId;
        });

        if (isRealyNewPost) {
          const sameFullPost = newPostListWithImages.find((newPost) => {
            return newPost.instagramPost.frisbuyId === newMedia.postId;
          });

          if (sameFullPost) {
            postListWithImages.value.push(sameFullPost);
          }
        }
      }
    });
  } catch (e) {
    // TODO: add types to Error `e` to use it to message
    throw Error("Failed to get CustomersMediaList");
  }
}

async function updatePostList(
  page: number | undefined = undefined,
  isForceUpdate: boolean = false
) {
  const { embedId, skuId, groupId, srcDomain } = props.settings;
  const apiDefaults = { embedId, skuId, groupId, srcDomain };

  const pageForLoad = page || selectedPage.value;

  const filterOptions: TPostsFilterOptions = {
    page: pageForLoad,
    orgerBy: "provider_created_at",
    sort: filterSort.value?.value,
    ratingFilter: filterRating.value?.value,
    current_variant: filterSegment.value?.value,
  };

  // TODO: add request's error handler
  const postsInfo = await getPostsInfo(apiDefaults, filterOptions);
  const newPosts = postsInfo.posts;

  if (isForceUpdate) {
    postList.value = newPosts;
  }

  const pageIndex = perPage * (pageForLoad - 1);
  newPosts.forEach((post: IMarketplaceReviewsPost, idx: number) => {
    postList.value[pageIndex + idx] = post;

    const isRealyNewPost = !postListWithImages.value.find((postForFind) => {
      return (
        postForFind?.instagramPost.frisbuyId === post.instagramPost.frisbuyId
      );
    });

    if (isRealyNewPost) {
      postListWithImages.value.push(post);
    }
  });

  postCount.value = postsInfo.postCount;
}

// Posts
//#region get parsed post source
function getParsedReviewDate(post: IMarketplaceReviewsPost) {
  const postDate = new Date(post.instagramPost.createdAt);

  const year = postDate.toJSON().split("-")[0];
  const month = postDate.toJSON().split("-")[1];
  const day = postDate.toUTCString().split(" ")[1];

  const currentDate = new Date();

  let isToday =
    postDate.setHours(0, 0, 0, 0) === currentDate.setHours(0, 0, 0, 0);
  let isYesterday =
    postDate.setDate(postDate.getDate() + 1) ===
    currentDate.setDate(currentDate.getDate());

  let postDateLocale = `${day}.${month}.${year}`;

  if (isToday) {
    postDateLocale = "Сегодня";
  } else if (isYesterday) {
    postDateLocale = "Вчера";
  }

  return postDateLocale;
}
function getParsedReviewTime(post: IMarketplaceReviewsPost) {
  const postDate = new Date(post.instagramPost.createdAt);
  const time = postDate.toUTCString().split(" ")[4].slice(0, -3);

  return time;
}
//#endregion get parsed post source

// Selecting post
const selectedPost = ref<IMarketplaceReviewsPost | null>(null);
const selectedPostIndex = ref<number | null>(null);
const selectedMediaIndex = ref<number | null>(null);

function selectPost(
  postId: number,
  media?: imageWithPostId,
  isInPopup: boolean = false
) {
  if (postId < 0) {
    console.error(`postIndex is ${postId}. Expected Number (>= 0)`);
    return;
  }

  const postById = postListWithImages.value.find(
    (post) => post?.instagramPost.frisbuyId === postId
  );

  const postIndex = postListWithImages.value.findIndex(
    (post) => post?.instagramPost.frisbuyId === postId
  );

  if (!postById) {
    console.error(`postId (${postId}) not found`);
    return;
  }

  let mediaIndex = 0;
  if (media) {
    const findedMediaIndex = postById.media.findIndex((postMedia) => {
      return postMedia.imageUrl === media.imageUrl;
    });

    if (findedMediaIndex < 0) {
      console.warn(`media not found`);
    } else {
      mediaIndex = findedMediaIndex;
    }
  }

  const post = postListWithImages.value[postIndex];

  sendAnaliticEvent("ViewPic", {
    provPostId: post.instagramPost?.frisbuyId ?? post.providerPost.frisbuyId,
    fbProduct: post.frisbuyPost.id,
    igCode: post.instagramPost.shortcode,
    index: `[${mediaIndex}]`,
  });

  sendAnaliticEvent("ClickPic", {
    provPostId: post.instagramPost?.frisbuyId ?? post.providerPost.frisbuyId,
    fbProduct: post.frisbuyPost.id,
    igCode: post.instagramPost.shortcode,
  });

  selectedPost.value = postById;
  selectedPostIndex.value = postIndex;

  selectedMediaIndex.value = mediaIndex;

  if (isInPopup) {
    if (!nextPost.value) {
      updateAllCustomersMediaList();
    }
  } else {
    // NOTE: preload next page to give opprtunity select nextPost on nextPage via Popup
    const pageWithSelectedPost = Math.floor(postIndex / perPage) + 1;
    if (!isLastPage.value && postIndex === postList.value.length - 1) {
      updatePostList(pageWithSelectedPost + 1);
    }
  }

}

const prevPost = computed<IMarketplaceReviewsPost | undefined>(() => {
  if (!selectedPostIndex.value) {
    return undefined;
  }
  return postListWithImages.value[selectedPostIndex.value - 1];
});
function selectPrevPost() {
  if (!prevPost.value) {
    return;
  }

  selectPost(prevPost.value.instagramPost.frisbuyId);
}

const nextPost = computed<IMarketplaceReviewsPost | undefined>(() => {
  if (typeof selectedPostIndex.value !== "number") {
    return undefined;
  }
  return postListWithImages.value[selectedPostIndex.value + 1];
});
async function selectNextPost() {
  if (!nextPost.value) {
    return;
  }

  selectPost(nextPost.value.instagramPost.frisbuyId, undefined, true);
}

function closePopup() {
  selectedPost.value = null;
  selectedMediaIndex.value = null;
}
</script>
